import image1 from "../src/images/icon2.png";
import image2 from "../src/images/icon3.png";
import image3 from "../src/images/icon1.png";
import image4 from "../src/images/icon4.png";
import image5 from "../src/images/icon5.png";
import image6 from "../src/images/icon6.png";

const data = [
  {
    img: image1,
    text: "Full Stack Development",
  },
  {
    img: image2,
    text: "Android Development",
  },
  {
    img: image3,
    text: "Cloud Computing",
  },
  {
    img: image4,
    text: "Big Data and IOT",
  },
  {
    img: image5,
    text: "Machine Learning",
  },
  {
    img: image6,
    text: "Java Foundation with Data Structures",
  },
];

export default data;
